import { watch } from 'vue'

import { useAuthStore } from '@/auth/useAuthStore'
import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

import { useBrazeStore } from './useBrazeStore'

const BRAZE_WEB_SDK_FLAG = 'olympus.brazeWebSdk'

export const useBrazeLifecycle = (): void => {
  const authStore = useAuthStore()
  const brazeStore = useBrazeStore()
  // Read the flag reactively, not once: the Unleash client loads flags
  // asynchronously, so an imperative check at login can run before the flag has
  // resolved and would bail permanently. Watching it means init fires whenever
  // both the user and the flag are ready, in whichever order they settle.
  const { enabled: isBrazeWebSdkEnabled } =
    useReactiveFeatureFlag(BRAZE_WEB_SDK_FLAG)

  watch(
    [(): string | undefined => authStore.user?.id, isBrazeWebSdkEnabled],
    ([userId, enabled]) => {
      if (!userId || !enabled) {
        brazeStore.shutdownBraze()
        return
      }
      void brazeStore.initializeBraze()
    },
    { immediate: true }
  )
}
